export const openTextMaxChars = 400;
